import { each } from '@antv/util';
import Element from '../../../geometry/element/';
import Action from '../base';
import { getElementsByState } from '../util';

/**
 * ç¶æé Action çåºç±»
 * @abstract
 * @class
 * @ignore
 */
abstract class StateBase extends Action {
  /**
   * ç¶æåç§°
   */
  protected stateName: string = '';

  /**
   * è®¾ç½®ç¶ææ¯å¦æ¿æ´»
   * @param enable ç¶æå¼
   */
  protected abstract setStateEnable(enable: boolean);

  /**
   * æ¯å¦å·ææä¸ªç¶æ
   * @param element å¾è¡¨ Element åç´ 
   */
  protected hasState(element: Element): boolean {
    return element.hasState(this.stateName);
  }
  /**
   * è®¾ç½®ç¶ææ¿æ´»
   * @param enable ç¶æå¼
   */
  protected setElementState(element: Element, enable: boolean) {
    // é²æ­¢éªç
    element.setState(this.stateName, enable);
  }

  /**
   * è®¾ç½®ç¶æ
   */
  public setState() {
    this.setStateEnable(true);
  }

  /**
   * æ¸é¤ææ Element çç¶æ
   */
  public clear() {
    const view = this.context.view;
    this.clearViewState(view);
  }

  protected clearViewState(view) {
    const elements = getElementsByState(view, this.stateName);
    each(elements, (el: Element) => {
      this.setElementState(el, false);
    });
  }
}

export default StateBase;
